import { pipe, t, E, s, RR } from '@packages/prelude'
import * as domain from '@packages/domain'
import { ConfigurationData } from '~/types'

// Utility function to escape HTML entities
const convertQuotes = (str: string): string =>
  pipe(
    str,
    t.NonEmptyString.decode,
    E.map(s.replace(/"/g, '&quot;')),
    E.getOrElse(() => str)
  )

/**
 * Generate configuration data from selected options
 */
export const generateConfigurationData = (
  selectedOptions: RR.ReadonlyRecord<string, ReadonlyArray<domain.Option.Type>>,
  price: number,
  configurationId: number,
  productId: number
): ConfigurationData => ({
  options: Object.entries(selectedOptions).flatMap(([key, options]) =>
    options.map(option => ({
      key,
      name: convertQuotes(option.name),
      description: convertQuotes(option.description),
      price: option.price,
      image: option.image,
      category: convertQuotes(option.category)
    }))
  ),
  totalPrice: price,
  configurationId,
  productId,
  timestamp: new Date().toISOString()
})
